import {Component, Input} from '@angular/core';
import {AbstractControl} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {DatePipe} from '../pipes/date.pipe';
import {ReplaySubject} from 'rxjs';
import {TranslatePipe} from '@brunata-angular/util';
import {NumberPipe} from '../pipes/number.pipe';
import {ValidationPopoverComponent} from './validation-popover.component';

@Component({
    selector: 'app-control-messages',
    templateUrl: './control-messages.component.html',
    standalone: true,
    imports: [CommonModule, DatePipe, TranslatePipe, NumberPipe, ValidationPopoverComponent],
})
export class ControlMessagesComponent {
    protected readonly control$ = new ReplaySubject<AbstractControl>();

    @Input({required: true}) set control(control: AbstractControl) {
        this.control$.next(control);
    }
}
